// extracted by css-extract-rspack-plugin
export default {"emphasis":"src-Emphasis-emphasis-c89ff0d4"};